import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import { createStyles } from 'antd-style';
export var useStyles = createStyles(function (_ref, visible) {
  var token = _ref.token,
    css = _ref.css,
    stylish = _ref.stylish,
    cx = _ref.cx;
  return cx(stylish.blur, css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n      pointer-events: ", ";\n\n      transform: translateY(", ");\n\n      padding-inline: 12px !important;\n\n      opacity: ", ";\n      background: ", ";\n      border-color: ", " !important;\n      border-radius: 16px !important;\n      backdrop-filter: blur(16px);\n    "])), visible ? 'all' : 'none', visible ? 0 : '16px', visible ? 1 : 0, token.colorFillSecondary, token.colorFillTertiary));
});